<div class="main-container-finance">
  <div class="breadcrumb">
    <a (click)="backToDashboard()" class="crumb crumb-link">Finance Dashboard</a>
    <span class="crumb-sep">/</span>
    <a (click)="backToDetails()" class="crumb crumb-link">Finance Details</a>
    <span class="crumb-sep">/</span>
    <span class="crumb crumb-current">Project History</span>
  </div>

  <mat-card class="content-card">
    <div class="section-header">
      <div class="section-title">
        <span>History</span>
      </div>
      <div class="section-actions">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            placeholder="Search"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
          />
          <button
            *ngIf="searchText"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <button
          mat-stroked-button
          class="download-btn"
          type="button"
          (click)="onDownload()"
        >
          <mat-icon>download</mat-icon>
          Download
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="state-block">Loading…</div>
    <div *ngIf="errorMessage && !loading" class="state-block state-error">{{ errorMessage }}</div>

    <div *ngIf="!loading && !errorMessage" class="history-table-wrapper">
      <table mat-table [dataSource]="pageRows" class="history-table">

        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ formatDate(row.startDate) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ formatDate(row.endDate) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="hiringStatus">
          <th mat-header-cell *matHeaderCellDef>Hiring Status</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            <span class="status-cell">
              <mat-icon class="status-icon" [ngClass]="hiringStatusIconClass(row.hiringStatus)">
                {{ hiringStatusIcon(row.hiringStatus) }}
              </mat-icon>
              <span>{{ formatHiringStatus(row.hiringStatus) }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="supportingLob">
          <th mat-header-cell *matHeaderCellDef>Supporting LOB</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.supportingLob || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dntIndiaLeader">
          <th mat-header-cell *matHeaderCellDef>D&amp;T India Leader</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.dntIndiaLeader || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="projectNameId">
          <th mat-header-cell *matHeaderCellDef>Project Name &amp; ID</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            <div class="project-name">{{ row.projectName || '—' }}</div>
            <div class="project-id" *ngIf="row.projectIdCode">{{ row.projectIdCode }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="allocationPct">
          <th mat-header-cell *matHeaderCellDef>Allocation</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ formatAllocation(row.allocationPct) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="capexOpex">
          <th mat-header-cell *matHeaderCellDef>CAPEX/OPEX</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ formatCapexOpex(row.capexOpex) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="poType">
          <th mat-header-cell *matHeaderCellDef>PO Type</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.poType || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="locationType">
          <th mat-header-cell *matHeaderCellDef>Location Type</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.locationType || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="poiType">
          <th mat-header-cell *matHeaderCellDef>POI Type</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.poiType || '—' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="employer">
          <th mat-header-cell *matHeaderCellDef>Employer</th>
          <td mat-cell *matCellDef="let row" [class.released-cell]="row.isReleased">
            {{ row.employer || '—' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
            [class.row-released]="row.isReleased"></tr>
      </table>

      <div *ngIf="filteredRows.length === 0" class="state-block empty-block">
        <mat-icon class="empty-icon">history_toggle_off</mat-icon>
        <p class="empty-title">No history yet</p>
        <p class="empty-hint">
          Edit-history was suspended during the migration import. Once
          finance edits resume through the Edit Resource Info flow, every
          change lands here in chronological order.
        </p>
      </div>

      <div class="table-footer" *ngIf="filteredRows.length > 0">
        <div class="footer-summary">
          Records {{ pageStart }}-{{ pageEnd }} of {{ filteredRows.length }}
          <span class="footer-sep">•</span>
          Per Page
        </div>
        <mat-paginator
          [length]="filteredRows.length"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true"
          (page)="onPageEvent($event)"
        ></mat-paginator>
      </div>
    </div>
  </mat-card>
</div>
